import { useState } from "react";
import { Clock } from "lucide-react";
import type FileAssetDTO from "../../types/dtos/fileAssets/FileAssetDTO";
import type FileProps from "../../types/ui/files/FileProps";
import formatUtcDateTime from "../../helpers/dateTimeHelper";
import FileActionsMenu from "./FileActionsMenu";
import FilePreview from "./FilePreview";

export interface FileCardPreviewProps extends FileProps {
  file: FileAssetDTO;
  actionsEnabled?: boolean;
  onPreview: (index: number) => void;
}

export default function FileCardPreview({
  file,
  index,
  actionsEnabled = true,
  onPreview,
  onDelete,
}: FileCardPreviewProps) {
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDelete = (index: number) => {
    setIsDeleting(true);
    onDelete?.(index);
  };

  return (
    <div
      className="bg-white rounded shadow hover:shadow-lg transition relative group cursor-pointer"
      onClick={() => onPreview(index)}
    >
      {/* RIGHT TOP MENU */}
      {actionsEnabled && (
        <div
          className="absolute top-2 right-2 z-50"
          onClick={(e) => e.stopPropagation()}
        >
          <FileActionsMenu
            file={file}
            index={index}
            onPreview={onPreview}
            onDelete={handleDelete}
          />
        </div>
      )}

      {/* PREVIEW */}
      <div className="w-full h-40 bg-gray-100 overflow-hidden">
        {isDeleting ? (
          <div className="flex w-full h-full items-center justify-center text-gray-400 text-sm animate-pulse">
            Deleting...
          </div>
        ) : (
          <FilePreview {...file} FileSize="medium" />
        )}
      </div>

      {/* INFO */}
      <div className="p-3 space-y-1">
        <p className="text-sm font-medium truncate">{file.OriginalFileName}</p>

        <div className="flex items-center gap-1 text-xs text-gray-500">
          <Clock size={12} />
          {formatUtcDateTime(file.CreatedOn)}
        </div>
      </div>
    </div>
  );
}
